export enum AppRoutes {
  Default = "/",
  Clients = "/clients",
  Exchange = "/exchange",
  Takeover = "/takeover",
  InternetRegistration = "/internetregistration",
  SystemSettings = "/system-settings",
  Statistic = "/statistic",
  Appointments = "/appointments",
  Assignments = "/assignments",
  Ambulanzes = "/ambulanzes",
  PriorityRequests = "/priority-requests",
  Edicts = "/edicts",
  AttendanceList = "/attendance-list",
  CourtHearings = "/court-hearings",
  DutySchedule = "/duty-schedule",
  Calculators = "/calculators",
}
